var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('span',{staticClass:"pwa-currency"},[_vm._v(_vm._s(_vm.showSymbol ? _vm.currency.symbol : '')),(_vm.showIcon)?_c('img',{staticClass:"pwa-currency-icon",style:({height: _vm.iconHeight}),attrs:{"src":_vm.getBrandImageSrc(`${_vm.currency.icon}.svg`),"alt":_vm.currency.icon}}):_vm._e()])
}
var staticRenderFns = []

export { render, staticRenderFns }